import React from 'react';
import { Sparkles } from 'lucide-react';
const items = ['Streak-free guarantee', 'Flat, upfront pricing', 'Shoes off, drop cloths down', 'Screens & tracks included', 'Same-day quotes', 'Background-checked crews'];
export function Marquee() {
  const loop = [...items, ...items];
  return <div className="overflow-hidden border-b-4 border-[#0B1B2B] bg-[#7FD8FF] py-4" data-id="element-87" data-mp="2dlcbu2k0tfcv">
      <div className="flex w-max animate-[marquee_28s_linear_infinite] items-center gap-8 pr-8" data-id="element-88" data-mp="3b8uty3zknttj">
        {loop.map((item, i) => <span key={`${item}-${i}`} className="flex items-center gap-3 whitespace-nowrap text-base font-extrabold uppercase tracking-[0.14em] text-[#0B1B2B]" data-id="element-89" data-mp="36ajijotmpb97" data-mpi={i}>
            <Sparkles className="h-4 w-4" aria-hidden="true" data-id="element-90" data-mp="2x7s4rida63ee" />
            {item}
          </span>)}
      </div>
    </div>;
}